import React, { useEffect, useState } from "react";
import PageBanner from "../../components/PageBanner";
import DocumentService from "../../services/document";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";
import PdfViewer from "../../components/document/PdfViewer";
import "../../components/document/pdf-viewer.css";

export default function Document() {
  let [documentData, setDocumentData] = useState(null);
  let [documentBanner, setDocumentBanner] = useState([]);
  // เอกสารที่กำลังเปิดอ่านอยู่ { url, title } — null คือปิด viewer
  let [viewing, setViewing] = useState(null);

  let { lang } = useParams();

  useEffect(() => {
    window.scrollTo(0, 0);
    getDocumentData();
    getDocumentBanner();
  }, []);

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  const getDocumentData = async () => {
    try {
      let res = await DocumentService.getDocument();
      setDocumentData(res);
    } catch {
      console.error();
    }
  };

  // เปิดใน viewer ของเราเอง (อ่านอย่างเดียว) แทน window.open ที่จะได้ viewer
  // ของ browser พร้อมปุ่ม download/print มาด้วย
  function openFile(data) {
    const file = data.file && data.file[0];
    if (!file) return;
    setViewing({
      url: file.url,
      title:
        (lang === "th" ? data.documentName?.detail_TH : data.documentName?.detail_EN) ||
        data.documentName?.detail_TH ||
        file.name ||
        "",
    });
  }

  const getDocumentBanner = async () => {
    try {
      let res = await BannerService.getBanner(7);
      setDocumentBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "Document", href: "/document" }];

  return (
    <div id="resource" className="pt-[135px] lg:pt-[0px]">
      {viewing && (
        <PdfViewer
          url={viewing.url}
          title={viewing.title}
          lang={lang}
          onClose={() => setViewing(null)}
        />
      )}

      <PageBanner
        text_th={"เอกสารเผยแพร่"}
        text_en={"Document"}
        banner={documentBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* นัดหมาย */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "th" ? "เอกสารเผยแพร่" : "Documents"}
            </h1>

            <div className="flex flex-col md:flex-row gap-[40px] mt-[30px] items-start relative">
              {/* เมนูหมวดด้านซ้าย: ตัวเล็กลงให้ชื่อยาวอยู่บรรทัดเดียว (จอใหญ่)
                  และเว้นบน 20px ให้บรรทัดแรกตรงกับหัวข้อหมวดแรกฝั่งขวา (ที่มี pt-[20px]) */}
              <div className="flex flex-col gap-[15px] md:w-[40%] md:shrink-0 md:pt-[20px] sticky top-[150px] self-start">
                {documentData &&
                  documentData.map((item, i) => (
                    <h1 
                      key={i} 
                      onClick={() => {
                        const element = document.getElementById(`doc-section-${i}`);
                        if (element) {
                          const y = element.getBoundingClientRect().top + window.scrollY - 120;
                          window.scrollTo({ top: y, behavior: 'smooth' });
                        }
                      }}
                      className="text-left text-body xl:text-lead font-medium cursor-pointer hover:text-blue transition-colors duration-300"
                    >
                      {lang === "th"
                        ? item.name.detail_TH
                        : item.name.detail_EN}
                    </h1>
                  ))}
              </div>

              <div className="flex flex-col gap-[60px] md:border-darkGray md:border-l-[1px] md:flex-1 md:min-w-0">
                {documentData &&
                  documentData.map((item, i) => (
                    <div id={`doc-section-${i}`} key={i} className="flex flex-col gap-[24px] md:pl-[50px] pt-[20px]">
                      <h1 className="text-title font-medium text-left text-blue">
                        {lang === "th"
                          ? item.name.detail_TH
                          : item.name.detail_EN}
                      </h1>

                      {item.document &&
                        item.document.map((docItem, j) => (
                          <div
                            key={j}
                            onClick={() => openFile(docItem)}
                            className="flex gap-[25px] items-center group cursor-pointer"
                          >
                            <div className="w-[28px] h-[28px] rounded-full bg-lightGray group-hover:bg-blue transition-colors duration-300 flex-shrink-0" />
                            <h1 className="text-lead font-medium group-hover:text-blue transition-colors duration-300">
                              {lang === "th"
                                ? docItem.documentName?.detail_TH
                                : docItem.documentName?.detail_EN}
                            </h1>
                          </div>
                        ))}
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
